var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.office_name != 'Principal')?_c('span',{staticClass:"label-local"},[_vm._v("Sucursal: ")]):_vm._e(),_c('span',{staticClass:"storehouse-breadcrumb breadcrumb-office"},[_c('b',[_vm._v(_vm._s(_vm.office_name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }